import api from "./index";
import { ENDPOINTS } from "./endpoints";


export const createListedProduct = (data) =>
  api.post(ENDPOINTS.LISTED_PRODUCTS.CREATE, data);


export const listListedProductsByParams = (data) =>
  api.post(ENDPOINTS.LISTED_PRODUCTS.SEARCH, data);


export const getListedProductById = (id) =>
  api.get(ENDPOINTS.LISTED_PRODUCTS.BY_ID(id));


export const verifyListedProduct = (id, data) =>
  api.put(ENDPOINTS.LISTED_PRODUCTS.VERIFY(id), data);


export const deleteListedProduct = (id) =>
  api.delete(ENDPOINTS.LISTED_PRODUCTS.DELETE(id));